import type { CreatorExperienceId } from './experience-config';

export const CREATOR_GUIDE_VERSION = 1;

export type CreatorGuideStep = {
	title: string;
	description: string;
};

const EXPERIENCE_COPY: Partial<Record<CreatorExperienceId, CreatorGuideStep>> = {
	website: {
		title: 'Add your website address',
		description: 'Paste the page you want people to open after they scan your QR code.',
	},
	whatsapp: {
		title: 'Set up your WhatsApp message',
		description: 'Add the phone number and an optional opening message for new conversations.',
	},
	'business-card': {
		title: 'Add your business details',
		description:
			'Add your contact details, brand, and the actions people should take after scanning.',
	},
	'social-links': {
		title: 'Add your social links',
		description: 'Add your profile links and arrange them in the order visitors should see them.',
	},
};

export function getCreatorGuideStorageKey(experience: CreatorExperienceId) {
	return `qrcodly:creator-guide:${CREATOR_GUIDE_VERSION}:${experience}`;
}

export function getCreatorGuideSteps(experience: CreatorExperienceId): CreatorGuideStep[] {
	const firstStep = EXPERIENCE_COPY[experience] ?? {
		title: 'Add your QR code details',
		description: 'Enter the information people should receive after they scan your QR code.',
	};

	return [
		firstStep,
		{
			title: 'Watch the live preview',
			description:
				'Your QR code updates as you add valid content, so you can test it before publishing.',
		},
		{
			title: 'You can change the QR type',
			description:
				'Use Back at any time to return to the first step and choose a different QR code type.',
		},
		{
			title: 'Design, publish, and download',
			description:
				'Continue to customize the style, then name and publish your QR code when you are ready.',
		},
	];
}
